import { useCallback, useEffect, useMemo } from 'react';

import { useTableContext } from 'lib/context/TableContext/TableContext';
import { inRn } from 'lib/helpers/utility';

export const useTableAutoHeight = ({ count }) => {
  const { gridApi, gridWrapperRef, limit, autoHeight } = useTableContext();

  const isSinglePage = useMemo(() => {
    return inRn(count) <= inRn(limit);
  }, [count, limit]);

  const setAutoHeight = useCallback(() => {
    if (!gridApi) return;

    gridApi.setGridOption('domLayout', 'autoHeight');

    const wrapper = gridWrapperRef?.current;
    if (wrapper) {
      wrapper.style.height = count === 0 ? '400px' : 'auto';
    }
  }, [gridApi, gridWrapperRef, count]);

  const setFixedHeight = useCallback(() => {
    if (!gridApi) return;
    gridApi.setGridOption('domLayout', 'normal');

    const wrapper = gridWrapperRef?.current;
    if (wrapper) {
      wrapper.style.height = '100%';
    }
  }, [gridApi, gridWrapperRef]);

  const isAutoHeight = Boolean(autoHeight && isSinglePage && inRn(count) <= 10);

  const measureAutoHeight = useCallback(() => {
    if (!gridApi) return;
    if (isAutoHeight) {
      setAutoHeight();
    } else {
      setFixedHeight();
    }
  }, [gridApi, isAutoHeight, setAutoHeight, setFixedHeight]);

  useEffect(() => {
    measureAutoHeight();
  }, [measureAutoHeight]);

  return { isSinglePage, isAutoHeight };
};
